
const questions = {
  thereIsReception: 'e2c11194-6a80-46dc-917d-75d008b804a6', // There is a reception/service disk
  receptionIsOpen: '900cff53-2c4f-46f1-89c9-13d4e7cc375a', // The reception is open 24/7
  wheelchairForBorrow: '88dce346-f641-492b-a25a-141a09bd86f8', // There are wheelchair for borrow
  mobilityScooterForLoan: 'f7f1d25d-32f8-4199-8e8f-63379cbc9268', // There are mobility scooter for loan
  accessibleToiletsOnEachFloor: '9b23e895-f8a7-4709-8f4a-7d4091d5a02f', // There are accessible toilets on each floor
  toiletsAreFreeOfCharge: 'e2ee7a9d-fb03-4cd5-b400-9c110357ee8f', // Toilets are free of charge
  familyOrNursingRoom: '0a4ed870-bbdd-43d5-a2bb-01b6f92ad873', // There are X family or nursing room
  assistanceDogsAreWelcome: '1f8da58f-e280-451e-be70-f4b48a6df722', // Assistance dogs are welcome
  leashedDogsAreWelcome: '4ad066b9-1766-48ce-b33f-d0fe4b9a1807', // Leashed dogs are welcome in common areas
  visualSafetyAlarm: 'c776b3bb-0621-48ef-8207-e75c1962bee0', // There are visual fire safety alarms
  soundSafetyAlarm: 'c448e0a3-9189-4eac-abe6-90424773e787', // There are sound fire safety alarms
  accessibleRoomsOnTheGroundFloor: '53947c46-6b96-4186-9c5e-1687c17667bd', // There are Accessible rooms on the ground floor
  restRoom: '600ef9b6-a093-44b7-a03c-b6c841a972e6', // There is a rest room
  accessibleToilet: '0741099f-c5e3-47a1-92af-12c4777d451c', // There is an accessible toilet
  childToilet: '882f78ac-3567-40ca-858f-155a9a6739f1', // There is a child toilet
  automaticDoors: 'e81225a1-4748-4639-aba3-71ce462b349b', // Main entrances have automatic doors.
}

const shoppingMall = [
  questions.thereIsReception,
  questions.wheelchairForBorrow,
  questions.mobilityScooterForLoan,
  questions.accessibleToiletsOnEachFloor,
  questions.toiletsAreFreeOfCharge,
  questions.familyOrNursingRoom,
  questions.assistanceDogsAreWelcome,
  questions.leashedDogsAreWelcome,
  questions.visualSafetyAlarm,
  questions.soundSafetyAlarm,
]

const museum = [
  questions.thereIsReception,
  questions.wheelchairForBorrow,
  questions.mobilityScooterForLoan,
  questions.accessibleToiletsOnEachFloor,
  questions.toiletsAreFreeOfCharge,
  questions.familyOrNursingRoom,
  questions.assistanceDogsAreWelcome,
  questions.leashedDogsAreWelcome,
  questions.visualSafetyAlarm,
  questions.soundSafetyAlarm,
]

const restaurant = [
  questions.wheelchairForBorrow,
  questions.accessibleToiletsOnEachFloor,
  questions.toiletsAreFreeOfCharge,
  questions.familyOrNursingRoom,
  questions.assistanceDogsAreWelcome,
  questions.leashedDogsAreWelcome,
  questions.visualSafetyAlarm,
  questions.soundSafetyAlarm,
]

const hotel = [
  questions.receptionIsOpen,
  questions.wheelchairForBorrow,
  questions.mobilityScooterForLoan,
  questions.accessibleToiletsOnEachFloor,
  questions.toiletsAreFreeOfCharge,
  questions.assistanceDogsAreWelcome,
  questions.leashedDogsAreWelcome,
  questions.visualSafetyAlarm,
  questions.soundSafetyAlarm,
  questions.accessibleRoomsOnTheGroundFloor
]

const serviceHouse = [
  questions.receptionIsOpen,
  questions.wheelchairForBorrow,
  questions.mobilityScooterForLoan,
  questions.accessibleToiletsOnEachFloor,
  questions.toiletsAreFreeOfCharge,
  questions.assistanceDogsAreWelcome,
  questions.leashedDogsAreWelcome,
  questions.visualSafetyAlarm,
  questions.soundSafetyAlarm,
  questions.accessibleRoomsOnTheGroundFloor
]

const cottage = [
  questions.wheelchairForBorrow,
  questions.accessibleToiletsOnEachFloor,
  questions.assistanceDogsAreWelcome,
  questions.visualSafetyAlarm,
  questions.soundSafetyAlarm,
  questions.accessibleRoomsOnTheGroundFloor
]

const office = [
  questions.thereIsReception,
  questions.wheelchairForBorrow,
  questions.mobilityScooterForLoan,
  questions.accessibleToiletsOnEachFloor,
  questions.toiletsAreFreeOfCharge,
  questions.assistanceDogsAreWelcome,
  questions.leashedDogsAreWelcome,
  questions.visualSafetyAlarm,
  questions.soundSafetyAlarm,
  questions.restRoom,
]

const outdoorPlayground = [
  questions.toiletsAreFreeOfCharge,
  questions.assistanceDogsAreWelcome,
  questions.leashedDogsAreWelcome,
  questions.accessibleToilet,
  questions.childToilet
]

const indoorPlayground = [
  questions.thereIsReception,
  questions.automaticDoors,
  questions.toiletsAreFreeOfCharge,
  questions.assistanceDogsAreWelcome,
  questions.leashedDogsAreWelcome,
  questions.accessibleToilet,
  questions.childToilet
]

// TODO this set created because we've different database data (dev/live),
//  and it's needs only for testing, if u want to use it then just put devSet in questionSets = { <field>: *here* }
const devSet = [
  'a8082263-2816-48da-848d-650b66f1750f', // answer text yes 31.01.2023
  '72746744-f97e-4ba2-a79c-5788cf7dbf83', // TEXT YES
  '71f23765-601b-453b-b4bf-2883ca8179c2', // There is a wheelchair to borrow.
  '346e00ca-04fc-443e-b8bc-22d667dba135', // There is a reception.
  '2fda07ac-2edc-4a1e-9908-35b9db7fdca6', // Assistance dogs are allowed.
  '163d9790-2328-4c98-8cf0-61a3eece3f7f', // Answer text yes
]

export const questionSets: {[key: string]: string[]} = {
  shopping_mall: shoppingMall,
  museum: museum,
  hotel: hotel,
  office: office,
  outdoor_playground: outdoorPlayground,
  indoor_playground: indoorPlayground,
  restaurant: restaurant,
  cottage: cottage,
  service_house: serviceHouse
}

